const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// Open the Kerry's Golf Pro Shop (ShopMy) menu link in a new tab
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href*="shopmy.us"]').forEach(function (a) {
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener');
  });
});
